const cache = new Map();
const inflight = new Map();

const DEFAULT_TTL_MS = 5 * 60 * 1000;

export const cachedRequest = async (key, fetcher, ttlMs = DEFAULT_TTL_MS) => {
  const now = Date.now();
  const cached = cache.get(key);
  if (cached && cached.expiresAt > now) {
    return cached.value;
  }

  if (inflight.has(key)) {
    return inflight.get(key);
  }

  const promise = Promise.resolve()
    .then(fetcher)
    .then((value) => {
      cache.set(key, { value, expiresAt: Date.now() + ttlMs });
      inflight.delete(key);
      return value;
    })
    .catch((error) => {
      inflight.delete(key);
      throw error;
    });

  inflight.set(key, promise);
  return promise;
};

export const invalidateCachedRequest = (...keys) => {
  keys.forEach((key) => {
    cache.delete(key);
    inflight.delete(key);
  });
};

export const invalidateCachedRequestPrefix = (prefix) => {
  for (const key of cache.keys()) {
    if (key.startsWith(prefix)) {
      cache.delete(key);
    }
  }
  for (const key of inflight.keys()) {
    if (key.startsWith(prefix)) {
      inflight.delete(key);
    }
  }
};
